import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";
import { setSucessTab } from "../orders/orderSlice";
import { GetEditOrderDetails } from "../ordersSummary/orderSummarySlice";

// initial state
export const initialState = {
  loading: false,
  error: null,
  success: false,
  policyDetails: [],
  tab6QtnRetriveSuccess: false,
  UnderwritingQtnRetriveSuccess: false,
  questionDetailsForPurchaserMortgagor: [],
  questionDetailsForLenders: null,
  questionDetailsForUnderwriting: null,
  unifiedQuestionsForConsentStatements: null,
  questionDetailsForAdditionalInfo: null,
  questionDetailsForLenderTab6: [],
  propertyIDSaved: [],
  propertyListSaved: [],
  insuredMortgageIDSaved: [],
  propertyArrayFromEdit: [],
  isWarningMessage: false,
  isValidationsPerformed: false,
};

// our slice
const unifiedQuestionSlice = createSlice({
  name: "unifiedQuestions",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setLoadingFalse: (state) => {
      state.loading = false;
      state.success = true;
    },
    setErrors: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      state.success = false;
    },
    setSuccess: (state) => {
      state.loading = false;
      state.error = null;
      state.success = true;
      state.tab6QtnRetriveSuccess = false;
    },
    setTab6QtnRetriveSuccess: (state, { payload }) => {
      state.tab6QtnRetriveSuccess = payload;
    },
    setUnderwritingQtnRetriveSuccess: (state, { payload }) => {
      state.UnderwritingQtnRetriveSuccess = payload;
    },
    setUnifiedQuestionsForConsentStatements: (state, { payload }) => {
      state.unifiedQuestionsForConsentStatements = payload;
    },
    setUnifiedQuestionsForAddtionalInfo: (state, { payload }) => {
      state.questionDetailsForAdditionalInfo = payload;
    },
    setPolicyDetails: (state, { payload }) => {
      if (state.policyDetails.length === parseInt(payload.Index)) {
        state.policyDetails.push(payload);
      } else {
        state.policyDetails.splice(payload.index, 1, payload);
      }
    },
    setUnifiedQuestionsForPurchaserMortgagor: (state, { payload }) => {
      // if (
      //   state.questionDetailsForPurchaserMortgagor.length ===
      //   parseInt(payload.propertyIndex)
      // ) {
      //state.questionDetailsForPurchaserMortgagor.push(payload);
      // } else {
      //have to push to particular index of array
      state.questionDetailsForPurchaserMortgagor.splice(
        //fixed if multiple prop then last prop question not loading
        payload.propertyIndex,
        1,//removing 0 to 1 will fix the empty question issue in multi prop multi trans scenarios
        payload
      );
      //}
    },
    setRemoveQuestionObjectByProp: (state, { payload }) => {
      state.questionDetailsForPurchaserMortgagor.splice(payload, 1);
      //state.policyDetailsGlobal.splice(payload, 1);
    },
    setUnifiedQuestionsForLenders: (state, { payload }) => {
      state.questionDetailsForLenders = payload;
    },
    setUnifiedQuestionsForUnderwriting: (state, { payload }) => {
      state.questionDetailsForUnderwriting = payload;
    },
    setUnifiedQuestionsForLenderTab6: (state, { payload }) => {
      // if (
      //   state.questionDetailsForLenderTab6.filter(
      //     (x) => x.lenderIndex === payload.lenderIndex
      //   ).length > 0
      // ) {
      //   state.questionDetailsForLenderTab6.splice(
      //     payload.lenderIndex,
      //     1,
      //     payload
      //   );
      // } else {
      //   state.questionDetailsForLenderTab6.push(payload);
      // }
      state.questionDetailsForLenderTab6 = payload;

      // state.questionDetailsForLenderTab6.push(
      //   ...state.questionDetailsForLenderTab6,
      //   payload
      // );
      // let testObject = [...state.questionDetailsForLenderTab6];
      // testObject[payload.lenderIndex] = { ...payload };
      // testObject.map((ind) => (typeof ind === 'object' ? ind : null));
      // state.questionDetailsForLenderTab6 = testObject;

      // if (
      //   state.questionDetailsForLenderTab6.length ===
      //   parseInt(payload.lenderIndex)
      // ) {
      //   state.questionDetailsForLenderTab6.push(payload);
      // } else {
      // state.questionDetailsForLenderTab6.splice(
      //   payload.lenderIndex,
      //   1,
      //   payload
      // );
      // }
    },
    setRemoveQuestionObjectByLenderTab6: (state, { payload }) => {
      state.questionDetailsForLenderTab6.splice(payload, 1);
    },
    setPropertyID: (state, { payload }) => {
      state.propertyIDSaved = payload;
    },
    setPropertyList: (state, { payload }) => {
      state.propertyListSaved = payload;
    },
    setInsuredMortgageID: (state, { payload }) => {
      if (state.insuredMortgageIDSaved.length === parseInt(payload.index)) {
        state.insuredMortgageIDSaved.push(`${payload.index},${payload.ID}`);
      } else {
        state.insuredMortgageIDSaved.splice(
          payload.index,
          1,
          `${payload.index},${payload.ID}`
        );
      }
    },
    setPropertyArray: (state, { payload }) => {
      state.propertyArrayFromEdit = payload;
    },
    setIsWarningMessage: (state, { payload }) => {
      state.isWarningMessage = payload;
    },
    setIsValidationsPerformed: (state, { payload }) => {
      state.isValidationsPerformed = payload;
    },
  },
});

// export the actions
export const {
  setLoading,
  setLoadingFalse,
  setErrors,
  setSuccess,
  setPolicyDetails,
  setUnifiedQuestionsForPurchaserMortgagor,
  setRemoveQuestionObjectByProp,
  setUnifiedQuestionsForLenders,
  setUnifiedQuestionsForUnderwriting,
  setUnifiedQuestionsForLenderTab6,
  setTab6QtnRetriveSuccess,
  setUnderwritingQtnRetriveSuccess,
  setUnifiedQuestionsForConsentStatements,
  setUnifiedQuestionsForAddtionalInfo,
  setRemoveQuestionObjectByLenderTab6,
  setPropertyID,
  setPropertyList,
  setInsuredMortgageID,
  setPropertyArray,
  setIsWarningMessage,
  setIsValidationsPerformed,
} = unifiedQuestionSlice.actions;

export const unifiedQuestionSelector = (state) => state.unifiedQuestions;

// export the default reducer
export default unifiedQuestionSlice.reducer;

export const GetUnfiedQuestions = (questionResquest) => async (dispatch) => {
  try {
    dispatch(setLoading());
    dispatch(setUnderwritingQtnRetriveSuccess(true));
    if (questionResquest.orderTabID === 2)
      dispatch(
        setPolicyDetails({
          isExistingOwnerPolicyYesNo:
            questionResquest.isExistingOwnerPolicyYesNo,
          isOwnerPolicyYesNo: questionResquest.isOwnerPolicyYesNo,
          Index: questionResquest.propertyIndex,
        })
      );
    let req = {
      FileID: questionResquest.fileID,
      IsCommercial: questionResquest.isCommercial,
      LanguageCode: questionResquest.language,
      IsPurchase: questionResquest.isPurchase,
      IsOwnerPolicy: questionResquest.isOwnerPolicy,
      IsExistingOwnerPolicy: questionResquest.isExistingOwnerPolicy,
      IsLoanPolicy: questionResquest.isLoanPolicy,
      TabID: questionResquest.tabID,
      SectionName: questionResquest.sectionName,
      UserID: questionResquest?.userID,
      PropertyIndex: questionResquest.propertyIndex
    };

    const results = await http
      .post("QuestionAdmin/ReadUnifiedQuestionsForExpress", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      if (questionResquest.orderTabID === 2) {
        //dispatch(setPolicyDetails({ "isExistingOwnerPolicyYesNo": questionResquest.isExistingOwnerPolicyYesNo, "isOwnerPolicyYesNo": questionResquest.isOwnerPolicyYesNo, "Index": questionResquest.propertyIndex }))
        results.data.responseObject.propertyIndex =
          questionResquest.propertyIndex;
        dispatch(
          setUnifiedQuestionsForPurchaserMortgagor(results.data.responseObject)
        );
      } else if (questionResquest.orderTabID === 3) {
        dispatch(setUnifiedQuestionsForLenders(results.data.responseObject));
      } else if (questionResquest.orderTabID === 4) {
        dispatch(
          setUnifiedQuestionsForUnderwriting(results.data.responseObject)
        );
        dispatch(setUnderwritingQtnRetriveSuccess(false));
      } else if (questionResquest.orderTabID === 5) {
        dispatch(
          setUnifiedQuestionsForConsentStatements(results.data.responseObject)
        );
      } else if (questionResquest.orderTabID === 6) {
        dispatch(
          setUnifiedQuestionsForAddtionalInfo(results.data.responseObject)
        );
      }
      dispatch(setSuccess());
      // dispatch(setUnderwritingQtnRetriveSuccess(false));
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setErrors(errorMessage));
  }
};

//obsolete
export const saveAndGetUnfiedQuestionsForLenderTab6 =
  (saveDataRequest, getTab6QuestionRequest, userid, lenderIndex) =>
    async (dispatch) => {
      try {
        dispatch(setLoading());
        dispatch(setTab6QtnRetriveSuccess(true));
        let req = { UserID: userid, RequestObject: saveDataRequest };
        const results = await http
          .post("Order/SaveLenderInformation", req)
          .then((result) => {
            return result;
          });

        if (results.data.responseCode == 0) {
          let insuredMortgageID =
            results.data.responseObject.insuredMortgageID[0];
          let payload = { ID: insuredMortgageID, index: lenderIndex };
          dispatch(setInsuredMortgageID(payload));

          let getQuestionsTab6Req = {
            //need to check request format
            FileID: getTab6QuestionRequest.fileID,
            IsCommercial: getTab6QuestionRequest.isCommercial,
            LanguageCode: getTab6QuestionRequest.language,
            IsPurchase: getTab6QuestionRequest.isPurchase,
            IsOwnerPolicy: getTab6QuestionRequest.isOwnerPolicy,
            IsExistingOwnerPolicy: getTab6QuestionRequest.isExistingOwnerPolicy,
            IsLoanPolicy: getTab6QuestionRequest.isLoanPolicy,
            TabID: getTab6QuestionRequest.tabID,
            SectionName: getTab6QuestionRequest.sectionName,
            InsureMortgageID: insuredMortgageID,
          };

          const resultsSub = await http
            .post(
              "QuestionAdmin/ReadUnifiedQuestionsForExpress",
              getQuestionsTab6Req
            )
            .then((result) => {
              return result;
            });

          if (resultsSub.data.responseCode == 0) {
            resultsSub.data.responseObject.lenderIndex = lenderIndex;
            resultsSub.data.responseObject.insuredMortgageID = insuredMortgageID;
            dispatch(
              setUnifiedQuestionsForLenderTab6(resultsSub.data.responseObject)
            );
            dispatch(setSuccess());
            dispatch(setTab6QtnRetriveSuccess(false));
          }
          dispatch(setTab6QtnRetriveSuccess(false));
        }
        dispatch(setTab6QtnRetriveSuccess(false));
      } catch (error) {
        const errorMessage =
          error.response && error.response.data
            ? error.response.data.message
            : error.message;
        dispatch(setErrors(errorMessage));
        dispatch(setTab6QtnRetriveSuccess(false));
      }
    };

export const GetUnfiedQuestionsForLenderTab6 =
  (getTab6QuestionRequest, userid) => async (dispatch) => {
    try {
      dispatch(setLoading());
      let getQuestionsTab6Req = {
        //need to check request format
        FileID: getTab6QuestionRequest.fileID,
        IsCommercial: getTab6QuestionRequest.isCommercial,
        LanguageCode: getTab6QuestionRequest.language,
        IsPurchase: getTab6QuestionRequest.isPurchase,
        IsOwnerPolicy: getTab6QuestionRequest.isOwnerPolicy,
        IsExistingOwnerPolicy: getTab6QuestionRequest.isExistingOwnerPolicy,
        IsLoanPolicy: getTab6QuestionRequest.isLoanPolicy,
        TabID: getTab6QuestionRequest.tabID,
        SectionName: getTab6QuestionRequest.sectionName,
        InsureMortgageID: 0, //not required
        UserID: userid,
      };

      const resultsSub = await http
        .post(
          "QuestionAdmin/ReadUnifiedQuestionsForExpress",
          getQuestionsTab6Req
        )
        .then((result) => {
          return result;
        });

      if (resultsSub.data.responseCode == 0) {
        // for (let i = 0; i < insuredMortgageIDSaved.length; i++) {
        //   resultsSub.data.responseObject.lenderIndex = i;
        //   resultsSub.data.responseObject.insuredMortgageID =
        //     insuredMortgageIDSaved[i].split(",")[1];
        //     resultsSub.data.responseObject.questions=
        //     resultsSub.data.responseObject.questions.filter(
        //       (x) =>
        //         x.insuredMortgageID ===
        //         parseInt(insuredMortgageIDSaved[i].split(",")[1])
        //     );
        //   dispatch(setUnifiedQuestionsForLenderTab6(resultsSub.data.responseObject));
        // }
        dispatch(
          setUnifiedQuestionsForLenderTab6(resultsSub.data.responseObject)
        );
        dispatch(setSuccess());
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      dispatch(setErrors(errorMessage));
    }
  };

export const submitOrderTabs =
  (request, tabid, userid, { setTabValue, val }) =>
    async (dispatch) => {
      try {
        dispatch(setLoading());
        let url = null;
        if (tabid === 2) url = "Order/SavePropertyPurchaserMortgagorInformation";
        else if (tabid === 3) url = "Order/SaveLenderInformation";
        else if (tabid === 4) url = "Order/SaveLenderUnderWritingQuestions";
        else if (tabid === 5)
          url = "Order/SavePropertyAndOrderUnderWritingQuestions";
        let req = { UserID: userid, RequestObject: request };
        const results = await http.post(url, req).then((result) => {
          return result;
        });

        if (results.data.responseCode == 0) {
          if (tabid === 2) {
            dispatch(GetEditOrderDetails(request.FileID, userid));
            dispatch(setPropertyID(results.data.responseObject));
            let subreq = {
              FileID: request.FileID,
            };
            const subresults = await http
              .post("Order/GetPropertyListForPurchaserMortgagorByFileID", subreq)
              .then((result) => {
                return result;
              });
            if (subresults.data.responseCode == 0) {
              dispatch(setPropertyList(subresults.data.responseObject));
              dispatch(GetPropertyArrayByFileDetails(request.FileID, userid));
            }
          }
          if (tabid === 3) {
            dispatch(GetEditOrderDetails(request.FileID, userid));
            for (
              let i = 0;
              i < results.data.responseObject.insuredMortgageID.length;
              i++
            ) {
              let insuredMortgageID =
                results.data.responseObject.insuredMortgageID[i];
              let payload = { ID: insuredMortgageID, index: i };
              dispatch(setInsuredMortgageID(payload));
            }
            if (request?.LenderInfo?.length === 0) {
              tabid = tabid + 1;
            }
          }
          dispatch(setSucessTab(tabid + 1));
          setTabValue(typeof val === "number" ? val : tabid + 1, tabid + 1, true);
          dispatch(setSuccess());
        }
        if (results?.data?.responseCode == -1) {
          dispatch(setErrors(results?.data?.error));
        }
      } catch (error) {
        const errorMessage =
          error.response && error.response.data
            ? error.response.data.error
            : error.message;
        dispatch(setErrors(errorMessage));
      }
    };

export const GetValidationsForQuestions =
  (request, tabid, userid, { setError, t }) =>
    async (dispatch) => {
      try {
        dispatch(setLoading());
        dispatch(setIsValidationsPerformed(false));
        let req = { UserID: userid, RequestObject: request };
        const results = await http
          .post("Order/GetValidationsForQuestions", req)
          .then((result) => {
            return result;
          });
        if (results?.data?.responseCode == -1) {
          if (tabid === 5) {
            //for US#568230--------------------------For triggering validation from DB side
            if (results?.data?.responseObject?.length > 0) {
              results?.data?.responseObject?.forEach((item, i) => {
                if (
                  item?.groupChildIndex === null ||
                  item?.groupChildIndex === 0
                ) {
                  if (item?.isError) {
                    setError(
                      `UnderWritingProperties.${item?.propIndex - 1}.QuestionID_${item?.questionID
                      }`,
                      {
                        type: "manual",
                        message:
                          item?.errorMessage !== ""
                            ? t("RequiredFieldErrMsg")
                            : "",
                      }
                    );
                    focusElement(
                      `UnderWritingProperties.${item?.propIndex - 1}.QuestionID_${item?.questionID
                      }`
                    );
                  }
                } else if (item?.groupChildIndex > 0) {
                  if (item?.isError) {
                    setError(
                      `UnderWritingProperties.${item?.propIndex - 1
                      }.MultiFields.${item?.groupChildIndex - 1}.QuestionID_${item?.questionID
                      }`,
                      {
                        type: "manual",
                        message:
                          item?.errorMessage !== ""
                            ? t("RequiredFieldErrMsg")
                            : "",
                      }
                    );
                    focusElement(
                      `UnderWritingProperties.${item?.propIndex - 1
                      }.MultiFields.${item?.groupChildIndex - 1}.QuestionID_${item?.questionID
                      }`
                    );
                  }
                }
              });
            }
          }
          dispatch(setErrors(results.data.error));
        }
        dispatch(setLoadingFalse());
        dispatch(setIsValidationsPerformed(true));
      } catch (error) {
        const errorMessage =
          error.response && error.response.data
            ? error.response.data.error
            : error.message;
        dispatch(setErrors(errorMessage));
      }
    };

const focusElement = (name) => {
  const inputElement = document.querySelector(`[name="${name}"]`);
  if (inputElement) {
    inputElement.focus();
  }
};

export const setWarningMessages = (isWarning) => async (dispatch) => {
  dispatch(setIsWarningMessage(isWarning));
};

export const GetPropertyArrayByFileDetails =
  (FileID, UserID) => async (dispatch) => {
    try {
      dispatch(setLoading());
      let request = {
        FileID: FileID,
      };

      let req = { UserID: UserID, RequestObject: request };
      const results = await http
        .post("Order/GetAllFileDetailsByFileId", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        dispatch(setPropertyArray(results.data.responseObject.propertyList));
        dispatch(setSuccess());
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      dispatch(setErrors(errorMessage));
    }
  };
